export default __webpack_public_path__ + "static/media/Parallax-HUD-Pop-Up (Process) 4in1.28af8526.jpg";